exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-30x7X{padding:26px 20px;background-color:#042b75;border:solid 1px #001240}.card-30x7X:not(:last-child){margin-bottom:10px}.card-30x7X.warn-_lQ08{background-color:rgba(255,109,127,.24) !important;border:solid 1px #ff6d7f}.row-1LyNx{line-height:1.75rem}.nameContainer-2Tora{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;display:-webkit-box;display:-ms-flexbox;display:flex}.tooltipContainer-231fz{display:inline-block}.tooltipContainer-231fz .tooltip-1uELU,.tooltipContainer-231fz:hover .tooltip-1uELU{line-height:normal;max-width:250px;width:-webkit-max-content;width:-moz-max-content;width:max-content}.warnIcon-2cYm2{color:#ff6d7f;font-size:20px;margin-right:10px}.name-3dSoS{margin-bottom:0}.deleteButton-1i2Pe{text-align:right}.theme-dark .card-30x7X{background-color:#042b75}.theme-light .card-30x7X{background-color:#fff}", ""]);

// exports
exports.locals = {
	"card": "card-30x7X",
	"warn": "warn-_lQ08",
	"row": "row-1LyNx",
	"nameContainer": "nameContainer-2Tora",
	"tooltipContainer": "tooltipContainer-231fz",
	"tooltip": "tooltip-1uELU",
	"warnIcon": "warnIcon-2cYm2",
	"name": "name-3dSoS",
	"deleteButton": "deleteButton-1i2Pe"
};